import { loginStore } from "@/modules/login/store";
import { parametersStore } from "@/stores/parameters";

export const isValidEmail = (email: string) =>
  /^[a-zA-Z0-9_.-]+@[a-zA-Z0-9-]+(\.[a-zA-Z0-9-]+)*\.[a-zA-Z0-9]{2,6}$/.test(email);

export const isValidPhone = (phone: string) =>
  /^(1(?:3\d{3}|5[^4\D]\d{2}|8\d{3}|7(?:[01356789]\d{2}|4(?:0\d|1[0-2]|9\d))|9[189]\d{2}|6[567]\d{2}|4[579]\d{2})\d{6})$/.test(
    phone,
  );

export const isValidPassword = (password: string) =>
  /[\w\d()[\]{}\\/!~@#$%^&*_\-+='|:;"<>,.?]{6,30}/.test(password);

export const sensitiveWordCheck = (text: string): Promise<boolean> =>
  new Promise((resolve, reject) => {
    fetch(`${parametersStore.creatorHost}/get_prompt`, {
      method: "POST",
      headers: loginStore.jsonPostReqHeaders,
      body: JSON.stringify({ text, need_translate: false }),
    })
      .then((res) => res.json())
      .then((res) => {
        if (res.success) {
          resolve(true);
        } else {
          console.log("sensitive check fail: ", res.reason);
          reject(false);
        }
      })
      .catch((e) => {
        console.error("sensitive check error: ", e);
        reject(false);
      });
  });

export const stringByteLength = (
  str: string,
  config: {
    en: number;
    zh: number;
    emoji: number;
  } = {
    en: 1,
    zh: 2,
    emoji: 2,
  },
) => {
  const { en = 1, zh = 2, emoji = 2 } = config;
  if (!str) {
    return 0;
  }

  let bytesCount = 0;

  for (let i = 0; i < str.length; i++) {
    const c = str.charAt(i);
    const isChinese = cnRegex.test(c);
    const isEmoji = isEmojiCharacter(c);

    if (!c || str.charCodeAt(i) === 65039) {
      continue;
    }
    if (isChinese) {
      bytesCount += zh;
    } else if (isEmoji) {
      bytesCount += emoji;
    } else {
      bytesCount += en;
    }
  }
  return bytesCount;
};

const cnRegex = /\p{Unified_Ideograph}/u;

export const isEmojiCharacter = (value: string) => {
  value = String(value);
  for (let i = 0; i < value.length; i++) {
    const hs = value.charCodeAt(i);
    if (0xd800 <= hs && hs <= 0xdbff) {
      if (value.length > 1) {
        const ls = value.charCodeAt(i + 1);
        const uc = (hs - 0xd800) * 0x400 + (ls - 0xdc00) + 0x10000;
        if (0x1d000 <= uc && uc <= 0x1f77f) {
          return true;
        }
      }
    } else if (value.length > 1) {
      const ls = value.charCodeAt(i + 1);
      if (ls == 0x20e3) {
        return true;
      }
    } else {
      if (0x2100 <= hs && hs <= 0x27ff) {
        return true;
      } else if (0x2b05 <= hs && hs <= 0x2b07) {
        return true;
      } else if (0x2934 <= hs && hs <= 0x2935) {
        return true;
      } else if (0x3297 <= hs && hs <= 0x3299) {
        return true;
      } else if (
        hs == 0xa9 ||
        hs == 0xae ||
        hs == 0x303d ||
        hs == 0x3030 ||
        hs == 0x2b55 ||
        hs == 0x2b1c ||
        hs == 0x2b1b ||
        hs == 0x2b50
      ) {
        return true;
      }
    }
  }
  return false;
};
export function replaceAll(original: string, s1: string, s2: string): string {
  return String(original).replace(new RegExp(s1, "gm"), s2);
}

export const compressedUrl = (imgUrl: string, w: number) =>
  `${imgUrl}?x-oss-process=image/resize,w_${w}/format,jpg/interlace,1`;
